import React from 'react';
import { Arrow } from '../../../../icons/index';
import { navy } from '@zocdoc/branding/colors';
import styled from 'styled-components';
import { sharpSansSemibold } from '../../../../typography';

const BackArrowView = ({
    showArrow,
    text,
    clickBack,
    ...props
}) => (
    <BackContainer
        onClick={clickBack}
        {...props}
    >
        <Arrow
            color="#00234b"
            direction={Arrow.direction.left}
        />
        <BackText>{text}</BackText>
    </BackContainer>
);

const BackContainer = styled.div`
    display: inline;
`;

const BackText = styled.div`
    ${sharpSansSemibold(15, 24)}
    color: ${navy};
    display: inline;
    padding: 0 6px 0 8px;
`;

export default BackArrowView;
